<amplify-authenticator [hideSignUp]="true" *ngIf="!isAuthenticated" [loginMechanisms]="['email']">
  <ng-template amplifySlot="sign-in-footer">
    <div class="azure-sso-separator">
      <hr class="separator-line" />
      <span class="separator-text">or</span>
      <hr class="separator-line" />
    </div>
    <div class="azure-sso-btn-container">
      <button class="azure-sso-btn" (click)="SsoSignIn()">
        Login with <img src="../assets/slalom-logo-white.png" alt="SSO Logo" class="sso-logo" />SSO
      </button>
    </div>
    <div style="text-align: center">
      <button
        (click)="authenticator.toResetPassword()"
        class="amplify-button amplify-field-group__control"
        data-fullwidth="false"
        data-size="small"
        type="button"
        style="font-weight: normal">
        Reset Password
      </button>
    </div>
  </ng-template>
  <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
    <h2>Welcome, {{ user.username }}!</h2>
    <button (click)="signOut()">Sign Out</button>
  </ng-template>
</amplify-authenticator>

<div *ngIf="isAuthenticated" class="app-layout">
  <mat-toolbar class="app-toolbar">
    <div class="left-content">
      <mat-icon (click)="toggleSidenav()">menu</mat-icon>
      <strong>slalom</strong> drift
    </div>
    <div class="right-content">
      <button mat-icon-button [matMenuTriggerFor]="menu" class="user-menu-trigger">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #menu="matMenu" class="user-account-menu">
        <div class="user-menu-container">
          <div class="user-menu-header">
            <mat-icon class="user-avatar">account_circle</mat-icon>
            <div class="user-info">
              <span class="user-label">Logged in with</span>
              <span class="user-email">{{ userEmail }}</span>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="user-menu-actions">
            <button mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </mat-menu>
    </div>
  </mat-toolbar>

  <div class="content-container">
    <mat-sidenav-container>
      <mat-sidenav
        #sidenav
        [mode]="'side'"
        [opened]="true"
        [ngClass]="{ expanded: isOpen, collapsed: !isOpen }"
        [fixedInViewport]="true"
        [fixedTopGap]="64"
        class="sidebar">
        <mat-nav-list class="nav-list">
          <div
            class="nav-item-container"
            *ngFor="let item of menuItems"
            [class.active-link]="item.route === currentRoute"
            [hidden]="!item.show">
            <a mat-list-item class="menu-item" [routerLink]="item.route">
              <mat-icon [ngClass]="['nav-icon', item.className]">{{ item.icon }}</mat-icon>
              <span class="menu-text" [ngClass]="{ hidden: !isOpen }">{{ item.text }}</span>
            </a>
          </div>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
